import type { IThemePage, IThemePagesMap } from '~/stores/themePage';

import { useQueryGPThemePagesByStatus } from '~/modules/apps';
import { useThemePageStore } from '~/stores/themePage';
import { useEffect, useMemo } from 'react';

export interface IUseUnpublishedThemePagesResult {
  unpublishedThemePages: IThemePage[];
  isFetchingUnpublishedThemePages: boolean;
}

export const useUnpublishedThemePages = (): IUseUnpublishedThemePagesResult => {
  const themePages = useThemePageStore((state) => state.themePages);
  const setAllThemePagesMap = useThemePageStore((state) => state.setAllThemePagesMap);

  const { themePages: unpublishedThemePages, isFetching: isFetchingUnpublishedThemePages } =
    useQueryGPThemePagesByStatus({
      enabled: true,
      statusIn: ['DRAFT', 'PUBLISH_ERROR'],
    });

  const unpublishedThemePagesMap = useMemo(() => {
    const map: IThemePagesMap = {};
    for (const page of unpublishedThemePages) map[page.id] = page;
    return map;
  }, [unpublishedThemePages]);

  const themePagesMap = useMemo(() => {
    const map: IThemePagesMap = {};
    for (const page of themePages ?? []) map[page.id] = page;
    return map;
  }, [themePages]);

  useEffect(() => {
    setAllThemePagesMap({ ...unpublishedThemePagesMap, ...themePagesMap });
  }, [unpublishedThemePagesMap, themePagesMap, setAllThemePagesMap]);

  return { unpublishedThemePages, isFetchingUnpublishedThemePages };
};
